var exports = {
  "uA": "PullRequests__2omb8x",
  "B9": "PullRequest__jDZxAa",
  "qk": "PullRequestText__OM7W2r",
  "Rh": "Loading__ZkT0EL",
};

module.exports = exports;
